export function AvatarPlaceholder({
  className,
  style,
}: {
  className?: string;
  style?: unknown;
}) {
  return (
    <img
      style={style}
      className={className}
      src={`../../images/resource/user-placeholder.png`}
      alt="Avatar placeholder"
    />
  );
}
